import Vue from 'vue';

// Store that holds the authentication state using Vue.observable for reactivity
export const authStore = Vue.observable({
  user: JSON.parse(sessionStorage.getItem('user')) || null,
  isAuthenticated: !!sessionStorage.getItem('user')
});

// Methods to handle authentication state changes
export const authMethods = {
  setUser(user) {
    authStore.user = user;
    authStore.isAuthenticated = true;
    sessionStorage.setItem('user', JSON.stringify(user));
  },
  logout() {
    authStore.user = null;
    authStore.isAuthenticated = false;
    sessionStorage.removeItem('user');
  }
};
